import React, { PropTypes } from 'react';

const ProductItem = ({ id, product }) => {
  return (
    <tr>
      <td class="ten wide">{product.productLabel}</td>
      <td class="six wide">{product.manipulationLabel}</td>
    </tr>
  );
};

ProductItem.propTypes = {
  product: PropTypes.object.isRequired,
};

export default ProductItem;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/components/ProductItem.js